<template><Transition name="toast"><div v-if="toast" class="toast">✓ {{ toast }}</div></Transition></template>

<script setup>
import { useAppContext } from '../../composables/appContext'
const { toast } = useAppContext()
</script>
